import { routeabstract } from "./mainabstract";

interface IRouteAbsRow{
    routeAbstractRow: routeabstract;
}
export const IndentAbstractRow = (props: IRouteAbsRow) => {
    const { routeAbstractRow } = props;
    return(
        // style={{border: "1px solid light-grey"}}
        <tr style={{border: "1px solid #E5E4E2"}}>
        <td>{routeAbstractRow.col2}</td>
        <td>{routeAbstractRow.col3}</td>
        <td>{routeAbstractRow.col4}</td>
        <td>{routeAbstractRow.col5}</td>
        <td>{routeAbstractRow.col6}</td>
        <td>{routeAbstractRow.col7}</td>
        <td>{routeAbstractRow.col8}</td>
        <td>{routeAbstractRow.col9}</td>
        <td>{routeAbstractRow.col10}</td>
        <td style={{float:"right"}}>{routeAbstractRow.col11>0?routeAbstractRow.col11.toFixed(2):"0.00"}</td>
    </tr>

    )
}